import React, { useEffect, useState } from "react";

// @mui
import { styled, SxProps, Theme } from "@mui/material";

// @mui icon
import CircularProgress from "@mui/material/CircularProgress";

// mui component
import Tab from "../mui/Tab";
import Tabs from "../mui/Tabs";
import Stack from "../mui/Stack";

interface TabInterface {
  id: number;
  name: string;
}

interface Props {
  tabs: TabInterface[];
  isLoadingScoreTabs?: boolean;
  handleTabChange?: (parameterTypeId: number) => void;
  activeTab?: number;
  setActiveTab?: any;
}

const tabIndicatorStyles: SxProps<Theme> = {
  bgcolor: "transparent",
  height: "0px",
};

const StyledTab = styled(Tab)((theme) => ({
  transition: "color 0.3s, background-color 0.3s",
  border: "1px solid #AFAFAF",
  textTransform: "capitalize",
  borderRadius: "20px",
  background: "#FFFFFF",
  color: "#AFAFAF",
  marginRight: "20px",
  fontWeight: 600,
  minHeight: "27px",
  maxHeight: "34px",
  height: "30px",
  padding: "16px 10px",

  "&.Mui-selected": {
    fontWeight: 700,
    color: "#242424",
    backgroundColor: "#fff1b7",
    border: "1px solid #997906",
  },
}));

const TargetAchievementCategories: React.FC<Props> = (props) => {
  const { tabs, isLoadingScoreTabs, handleTabChange } = props;

  const [activeTab, setActiveTab] = useState<number>(0);

  useEffect(() => {
    setActiveTab(0);
  }, [tabs.length]);
  

  if (isLoadingScoreTabs) {
    return <CircularProgress />;
  }

  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: "space-between",
        borderBottom: "1px solid #D0D0D0",
        mb: "20px",
      }}
    >
      <Tabs
        value={activeTab}
        onChange={(event: React.SyntheticEvent, newValue: number) =>
          setActiveTab(newValue)
        }
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
        TabIndicatorProps={{
          sx: tabIndicatorStyles,
        }}
      >
        {tabs.map((tab: TabInterface) => (
          <StyledTab
            key={tab?.id}
            label={tab?.name}
            onClick={() => {
              if (handleTabChange) handleTabChange(tab?.id);
            }}
          />
        ))}
      </Tabs>
    </Stack>
  );
};

export default TargetAchievementCategories;
